export default function useSearchParams<T>() {
  const params = new URLSearchParams(window.location.search)
  const returnValue = {}
  for (const [key, value] of params.entries()) {
    returnValue[key] = value
  }
  return returnValue as T
}
